import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

// 具名导出用这个
import { WebViewConsole } from "./WebViewConsole";

// 如果你的 WebViewConsole 是默认导出，改成下面这个：
// import WebViewConsole from "./WebViewConsole";

export function DebugGestureUnlock() {
  const [enabled, setEnabled] = useState(false);

  const stepRef = useRef("topRight");
  const countRef = useRef(0);
  const timerRef = useRef(null);
  const lastTouchTimeRef = useRef(0);

  useEffect(() => {
    console.log("[DebugGesture] mounted");
  }, []);

  function resetGesture() {
    stepRef.current = "topRight";
    countRef.current = 0;

    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }

    // console.log("[DebugGesture] reset");
  }

  function closeWebViewConsole() {
    setEnabled(false);
    console.log("[DebugGesture] WebViewConsole closed");
  }

  function enableWebViewConsole() {
    setEnabled(true);
    resetGesture();
    console.log("[DebugGesture] WebViewConsole enabled");
  }

  function getArea(x, y) {
    const cornerSize = 280;
    const width = window.innerWidth;
    const height = window.innerHeight;

    if (x >= width - cornerSize && y <= cornerSize) {
      return "topRight";
    }

    if (x <= cornerSize && y <= cornerSize) {
      return "topLeft";
    }

    if (x <= cornerSize && y >= height - cornerSize - 80) {
      return "bottomLeft";
    }

    if (x >= width - cornerSize && y >= height - cornerSize - 80) {
      return "bottomRight";
    }

    return null;
  }

  function getRequiredCount(step) {
    if (step === "topRight") return 7;
    if (step === "bottomLeft") return 3;
    if (step === "bottomRight") return 3;
    if (step === "topLeft") return 3;
    return 999;
  }

  function getNextStep(step) {
    if (step === "topRight") return "bottomLeft";
    if (step === "bottomLeft") return "bottomRight";
    if (step === "bottomRight") return "topLeft";
    return null;
  }

  function handleGestureTap(area) {
    if (!area) return;

    const currentStep = stepRef.current;

    // console.log("[DebugGesture] area tap:", {
    //   area,
    //   currentStep,
    //   count: countRef.current,
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // });

    if (area !== currentStep) {
    //   console.log("[DebugGesture] not matched, reset", {
    //     currentStep,
    //     area,
    //   });

      resetGesture();

      // 点错后，只有右上角可以重新开始
      if (area === "topRight") {
        stepRef.current = "topRight";
        countRef.current = 1;
        // console.log("[DebugGesture] topRight count", countRef.current);
      }

      return;
    }

    countRef.current += 1;

    // console.log("[DebugGesture]", currentStep, "count", countRef.current);

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    // 每次点击之间最多间隔 2 秒
    timerRef.current = setTimeout(() => {
      resetGesture();
    }, 2000);

    const requiredCount = getRequiredCount(currentStep);

    if (countRef.current < requiredCount) {
      return;
    }

    const nextStep = getNextStep(currentStep);

    if (nextStep) {
      stepRef.current = nextStep;
      countRef.current = 0;

      console.log(
        `[DebugGesture] next step: ${nextStep} x${getRequiredCount(nextStep)}`
      );

      return;
    }

    enableWebViewConsole();
  }

  useEffect(() => {
    function onTouchStart(e) {
      lastTouchTimeRef.current = Date.now();

      const touch = e.touches && e.touches[0];
      if (!touch) return;

      const x = touch.clientX;
      const y = touch.clientY;
      const area = getArea(x, y);

    //   console.log("[DebugGesture] document touchstart", {
    //     x,
    //     y,
    //     area,
    //   });

      // 只记录，不阻止 WebGL 接收点击
      handleGestureTap(area);
    }

    function onMouseDown(e) {
      // 移动端 touch 后可能补发 mouse 事件，这里避免重复计数
      if (Date.now() - lastTouchTimeRef.current < 700) {
        return;
      }

      const x = e.clientX;
      const y = e.clientY;
      const area = getArea(x, y);

    //   console.log("[DebugGesture] document mousedown", {
    //     x,
    //     y,
    //     area,
    //   });

      // 只记录，不阻止 WebGL 接收点击
      handleGestureTap(area);
    }

    document.addEventListener("touchstart", onTouchStart, {
      capture: true,
      passive: true,
    });

    document.addEventListener("mousedown", onMouseDown, {
      capture: true,
    });

    return () => {
      document.removeEventListener("touchstart", onTouchStart, {
        capture: true,
      });

      document.removeEventListener("mousedown", onMouseDown, {
        capture: true,
      });

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return createPortal(
    <>
      {enabled && (
        <div
          id="debug-webview-console-wrapper"
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 2147483647,      
            pointerEvents: "none",
          }}
        >
          <WebViewConsole onClose={closeWebViewConsole} />
        </div>
      )}
    </>,
    document.body
  );
}